
import { defineComponent, PropType } from 'vue'
import CookiesCoreMixinVue from '@/modules/CookiesCoreMixin.vue'

export default defineComponent({
  mixins: [CookiesCoreMixinVue],
  props: {
    DialogIndex: Number,
    DialogData: { default: () => { return {} }, type: Object as PropType<DialogData> }
  },
  data () {
    return {
      Loading: [] as Array<'Loading'>,
      Saving: false
    }
  },
  methods: {
    SaveData () {
      this.DialogData.AfterDialogFunction(this.MEMRead('D_Calendar'), this.DialogData.Data)
    }
  },
  computed: {},
  mounted () {},
  unmounted () {},
  watch: {}
})
